export enum CommissionRequestSteps {
  COMPANY_DETAILS = 'companyDetails',
  PAYMENT_INSTRUCTIONS = 'paymentInstructions',
}

export enum ContriesMandatoryProvince {
  CANADA = 'ca',
  UNITED_STATES = 'us',
  AUSTRALIA = 'au',
}

export interface CompanyCommission {
  id: string;
  name: string;
  logo: string;
  country: string;
  type: string;
}

export enum CommissionPaymentStatus {
  UNKNOWN = 'UNKNOWN',
  OPEN = 'OPEN',
  GRACE_PERIOD = 'GRACE_PERIOD',
  AUTHORIZED = 'AUTHORIZED',
  CANCELED = 'CANCELED',
  PAID = 'PAID',
  RECEIVED = 'RECEIVED',
  IN_TRANSIT = 'IN_TRANSIT',
  CREDITED = 'CREDITED',
  EXPIRED = 'EXPIRED',
  PENDING_AUTHORIZATION = 'PENDING_AUTHORIZATION',
}

export const commissionRequestSuccessStatuses: string[] = [
  CommissionPaymentStatus.PENDING_AUTHORIZATION,
  CommissionPaymentStatus.IN_TRANSIT,
  CommissionPaymentStatus.CREDITED,
];

export const commissionRequestPendingStatuses: string[] = [
  CommissionPaymentStatus.UNKNOWN,
  CommissionPaymentStatus.OPEN,
  CommissionPaymentStatus.GRACE_PERIOD,
];

export enum ExpiredOptions {
  ALREAD_SENT_PAYMENT = 'ALREADY_SENT_PAYMENT',
  HAVE_NOT_SENT_PAYMENT = 'HAVE_NOT_SENT_PAYMENT',
}

export interface CommissionPayment {
  paymentAmount: string;
  paymentCurrency: string;
  convertedAmount?: string;
  convertedCurrency?: string;
  instructions?: string;
  paymentMethod?: number;
  instructionsExpiry?: string;
  parsedInstructions?: any;
  countryPayFrom: string;
  status: CommissionPaymentStatus;
  state?: string;
  createdAt: string;
}

export interface CommissionRequest {
  id: string;
  uuid: string;
  amountToSend: string;
  company: CompanyCommission;
  payment?: CommissionPayment;
  status?: CommissionPaymentStatus;
  expiryDate?: Date;
  providerName: string;
  proofOfPayment?: string;
}

export interface AmountToPay {
  requested: string;
  converted: string;
  currency: string;
  convertedCurrency: string;
  paymentMethod: string;
  paymentMethodId: number;
}

export interface CreatePaymentPayload {
  countryPayFrom: string;
  paymentAmount: number;
  paymentMethod: string;
  paymentMethodId: number;
  externalId: string;
  state?: string;
  companyAddress: string;
  companyCity: string;
  companyPostalCode: string;
  companyPhoneNumber: string;
  invoiceProfileId?: number;
  companyName?: string;
}

export type AlertMessagesType = {
  [key in CommissionPaymentStatus]?: AlertMessage;
};

export interface AlertMessage {
  message: string;
  style: string;
}

export interface CommissionRequestResponseAPI {
  record: CommissionRequestResponseAPI;
  success: boolean;
}

export interface CommissionRequestResponse {
  id: number;
  uuid: string;
  externalTransactionId?: string;
  amountToSend: string;
  invoiceNumber: string;
  providerName: string;
  paymentStatus: CommissionPaymentStatus;
  createdAt: string;
  invoiceFile?: string;
  proofOfPayment: string;
  deleted: boolean;
  type: string;
  companyCurrencyAccount: CompanyCurrencyAccount;
  payments: Payment[];
  commissionPaymentLink: CommissionPaymentLink[];
  invoiceProfile?: InvoiceProfile;
}

interface Currency {
  currency_id: string;
  is_supported: boolean;
  is_withdrawable: boolean;
  created_at: string;
  updated_at: string;
}

interface Company {
  company_id: string;
  name: string;
  country: string;
  company_verification_status_code: number;
  logo: string;
  welcome_background: string | null;
  created_at: string;
  updated_at: string;
  type: string;
  companySizeType: number;
}

interface CustomSpread {
  companyCurrencyAccountCustomSpreadId: number;
  spreadPercentage: string;
  createdAt: string;
}

interface CompanyCurrencyAccount {
  company_currency_account_id: string;
  external_id: string;
  account_name: string;
  created_at: string;
  updated_at: string;
  currency: Currency;
  company: Company;
  customSpread: CustomSpread;
}

interface Payment {
  uid: string;
  bankAccountId: string;
  countryPayFrom: string;
  state: string | null;
  paymentAmount: string;
  paymentCurrency: string;
  paymentMethod?: number;
  paymentMethodId: string;
  paymentPurpose: string;
  externalId: string;
  createdAt: string;
  updatedAt: string;
  companyRegNumber: string;
  instructions: string;
  instructionsExpiry: string;
  paymentDate: string | null;
  convertedAmount: string;
  convertedCurrency: string;
  invoiceProfileId: string | null;
  tmEducationId: string;
  redirectUrl: string;
  status: CommissionPaymentStatus;
}

interface CommissionPaymentLink {
  publicLinkId: number;
  uri: string;
  url: string;
  resourceType: string;
  expiresAt: string;
  createdAt: string;
  updatedAt: string;
}

export interface InvoiceProfile {
  id: number;
  profileName: string;
  companyAddress: string;
  city: string;
  country: string;
  province?: string;
  postalCode: string;
  phoneNumber: string;
  taxId?: string;
}
